import React, { useState, useEffect } from "react";
import "./index.scss";
import { useLocation, useHistory } from "react-router-dom";
import ContentTabs from "../POSupplierDevice/components/ContentTabs";
import WarehouseList from "./components/WarehouseList";
import WarehouseManagerList from "./components/WarehouseManagerList";
import WarehouseDetails from "./components/WarehouseDetails";
import SearchIcon from "../../svgs/search.svg";
import AddCircleIcon from "../../svgs/add-circle.svg";
import WarehouseCreateModal from "./components/WarehouseCreateModal";
import WarehouseManagerCreateModal from "./components/WarehouseManagerCreateModal";
import useDebounce from "../../../Shared/GeographyFilters/hooks/useDebounce";

const contentTabs = [
  {
    id: "warehouses",
    label: "Warehouses",
    allowedUserTypes: ["bkash-super-user", "warehouse_manager"],
  },
  {
    id: "warehouseManagers",
    label: "WH Managers",
    allowedUserTypes: ["bkash-super-user"],
  },
];

const WarehouseManagement = () => {
  const location = useLocation();
  const history = useHistory();

  const userType = JSON.parse(localStorage.getItem("currUserType"));

  const filteredContentTabs = contentTabs.filter((tab) =>
    tab.allowedUserTypes.includes(userType)
  );

  const [contentTab, setContentTab] = useState(() => {
    const params = new URLSearchParams(location.search);
    const subtabFromUrl = params.get("subtab");
    const defaultSubtab = filteredContentTabs[0]?.id || "warehouses";

    if (
      subtabFromUrl &&
      filteredContentTabs.find((tab) => tab.id === subtabFromUrl)
    ) {
      return subtabFromUrl;
    }
    return defaultSubtab;
  });
  const [localSearchTerm, setLocalSearchTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showWarehouseCreateModal, setShowWarehouseCreateModal] =
    useState(false);
  const [showWarehouseManagerCreateModal, setShowWarehouseManagerCreateModal] =
    useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [showWarehouseDetails, setShowWarehouseDetails] = useState(false);
  const [warehouseListKey, setWarehouseListKey] = useState(0);
  const [warehouseManagerListKey, setWarehouseManagerListKey] = useState(0);
  const [warehouseCurrentPage, setWarehouseCurrentPage] = useState(1);

  const handleWarehouseView = (warehouse) => {
    setSelectedWarehouse(warehouse);
    setShowWarehouseDetails(true);
  };

  const handleBackToList = () => {
    setShowWarehouseDetails(false);
    setSelectedWarehouse(null);
    const params = new URLSearchParams(location.search);
    params.delete("detailTab");
    history.replace(`${location.pathname}?${params.toString()}`);
  };

  const handleWarehouseCreated = () => {
    setWarehouseListKey((prev) => prev + 1);
  };

  const handleWarehouseManagerCreated = () => {
    setWarehouseManagerListKey((prev) => prev + 1);
  };

  const debouncedSearchTerm = useDebounce(localSearchTerm, 400);

  useEffect(() => {
    setSearchTerm(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentSubtab = params.get("subtab");

    if (
      !currentSubtab ||
      !filteredContentTabs.find((tab) => tab.id === currentSubtab)
    ) {
      params.set("subtab", contentTab);
      params.delete("detailTab");
      history.replace(`${location.pathname}?${params.toString()}`);
    } else if (contentTab !== currentSubtab) {
      params.set("subtab", contentTab);
      params.delete("detailTab");
      history.replace(`${location.pathname}?${params.toString()}`);
    }
  }, [
    contentTab,
    history,
    filteredContentTabs,
    location.search,
    location.pathname,
  ]);

  const handleContentTabChange = (tabId) => {
    setContentTab(tabId);
  };

  const componentMap = {
    warehouses: (
      <WarehouseList
        key={warehouseListKey}
        showWarehouseCreateModal={showWarehouseCreateModal}
        setShowWarehouseCreateModal={setShowWarehouseCreateModal}
        searchTerm={searchTerm}
        onWarehouseView={handleWarehouseView}
        currentPage={warehouseCurrentPage}
        setCurrentPage={setWarehouseCurrentPage}
      />
    ),
    warehouseManagers: (
      <WarehouseManagerList
        key={warehouseManagerListKey}
        showWarehouseManagerCreateModal={showWarehouseManagerCreateModal}
        setShowWarehouseManagerCreateModal={setShowWarehouseManagerCreateModal}
        searchTerm={searchTerm}
      />
    ),
  };

  if (showWarehouseDetails && selectedWarehouse) {
    return (
      <WarehouseDetails
        warehouse={selectedWarehouse}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <div className="content-section">
      <div className="content-header">
        {userType !== "warehouse_manager" && (
          <ContentTabs
            tabs={filteredContentTabs}
            contentTab={contentTab}
            setContentTab={handleContentTabChange}
          />
        )}
        <div className="filters-section">
          <div className="search-input">
            <img src={SearchIcon} alt="Search Icon" className="search-icon" />
            <input
              type="text"
              id="warehouse-number"
              value={localSearchTerm}
              onChange={(e) => setLocalSearchTerm(e.target.value)}
              placeholder="Search"
              className="search-input-field"
            />
          </div>
          {userType !== "warehouse_manager" && (
            <button
              className="create-btn"
              onClick={() => {
                contentTab === "warehouses"
                  ? setShowWarehouseCreateModal(true)
                  : setShowWarehouseManagerCreateModal(true);
              }}
            >
              <img src={AddCircleIcon} alt="Search Icon" className="btn-icon" />
              {contentTab === "warehouses"
                ? "Create New Warehouse"
                : "Create New Warehouse Manager"}
            </button>
          )}
          {showWarehouseCreateModal && (
            <WarehouseCreateModal
              showWarehouseCreateModal={showWarehouseCreateModal}
              setShowWarehouseCreateModal={setShowWarehouseCreateModal}
              onWarehouseCreated={handleWarehouseCreated}
            />
          )}
          {showWarehouseManagerCreateModal && (
            <WarehouseManagerCreateModal
              setShowWarehouseManagerCreateModal={
                setShowWarehouseManagerCreateModal
              }
              onManagerCreated={handleWarehouseManagerCreated}
            />
          )}
        </div>
      </div>
      <div className="content-body">{componentMap[contentTab]}</div>
    </div>
  );
};

export default WarehouseManagement;
